import { useMutation, useQueryClient } from '@tanstack/react-query';
import { submitPcmpMarketingExplanation } from '../api/pcmpProposals.api';
import type { PcmpMktExplanationPayload } from '../types/pcmpProposal.types';
import { pcmpActionCallbacks } from '../utils/pcmpActionCallbacks';

export function useSubmitPcmpMarketingExplanation(proposalId: number, onSuccess: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PcmpMktExplanationPayload) =>
      submitPcmpMarketingExplanation(proposalId, payload),
    ...pcmpActionCallbacks(queryClient, 'Explanation submitted', onSuccess),
  });
}
